export const DEFAULT_TTL_DAYS = 21;
export const ONE_DAY_MS = 24 * 60 * 60 * 1000;
export const ALGORITHM = 'aes-256-gcm' as const;
export const BROTLI_QUALITY = 4;

export const CART_SESSION_TRANSFER_FAILURE_REASONS = {
  EXPIRED: 'expired',
  CART_ID_MISMATCH: 'cart_id_mismatch',
  MALFORMED_OR_INVALID: 'malformed_or_invalid',
  NOT_OWNED_BY_ACCOUNT: 'not_owned_by_account',
} as const;

export type CartSessionTransferFailureReason =
	typeof CART_SESSION_TRANSFER_FAILURE_REASONS[keyof typeof CART_SESSION_TRANSFER_FAILURE_REASONS];

export const CART_SESSION_TRANSFER_LINK_ISSUE_QUERY_KEY = 'linkIssue';

export const AUTHENTICATED_QUOTE_LINK_QUERY_KEY = 'authenticatedQuote';

export const CART_SESSION_TRANSFER_LINK_ISSUE_MODAL_TITLE_KEYS = {
  EXPIRED: 'Quote link expired',
  INVALID: 'Issue with quote link',
  NOT_OWNED_BY_ACCOUNT: 'Quote not found',
} as const;

export const CART_SESSION_TRANSFER_LINK_ISSUE_MODAL_MESSAGE_KEYS = {
  EXPIRED: 'The link to this quote has expired. Please generate a new PDF quote.',
  INVALID: 'There is an issue with this link. Please generate a new PDF quote.',
  NOT_OWNED_BY_ACCOUNT: 'The quote you are trying to open could not be found associated to your account.',
} as const;
